import { render, staticRenderFns } from "./ButtonGlobal.vue?vue&type=template&id=82bcbb34&scoped=true&"
import script from "./ButtonGlobal.vue?vue&type=script&lang=js&"
export * from "./ButtonGlobal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGlobal.vue?vue&type=style&index=0&id=82bcbb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bcbb34",
  null
  
)

export default component.exports